<template>
  <div>
    <div class="w-full">
      <vs-alert class="mb-5" :active.sync="active1" icon-pack="feather" color="warning" icon="icon-alert-circle">
        Please select a Course, followed by a Module to access the Course Builder.
      </vs-alert>
      <vx-card id="courseCard" title="Courses">
        
        <vs-table stripe ref="courseTable" class="vs-con-loading__container" single @selected="handleSelectedCourse" pagination max-items="10" search :data="courses" v-scroll-to="'#moduleCard'">

          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ course.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ course.description }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ course.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedBy">
                {{ course.modifiedBy }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div v-show="!isHiddenModule" class="mt-8">
      <vx-card id="moduleCard" title="Modules">
        <vs-table stripe ref="moduleTable" class="vs-con-loading__container" single @selected="handleSelectedModule" pagination max-items="10" search :data="modules">

          <template slot="thead">
            <vs-th sort-key="id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedOn">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="mod" :key="indextr" v-for="(mod, indextr) in data">

              <vs-td :data="data[indextr].id">
                {{ mod.id }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ mod.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ mod.description }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ mod.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modiefiedBy">
                {{ mod.modifiedBy }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        selected: [],
        isHiddenModule: true,
        courses: [],
        modules:[],
        active1: false,
      }
    },
    methods: {
      loadCourseData() {
        const self = this;

        var onSuccess = function (response) {
          self.courses = response.data.filter(x => !x.isReadOnly);;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.courseTable.$el);
          self.$refs.courseTable.searchx = "";
        };

        self.$ajaxGet(self, "course/listcourses", onSuccess, onFinally);
      },
      loadModuleData(id) {
        const self = this;

        var onSuccess = function(response) {
          self.modules = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.moduleTable.$el);
          self.$refs.moduleTable.searchx = "";
        };

        self.$ajaxGet(self, "module/listcoursemodule/" + id, onSuccess, onFinally);
      },
      handleSelectedCourse(course) {
        this.isHiddenModule = false;
        this.showLoadingOnModuleTable();
        this.loadModuleData(course.id);
      },
      handleSelectedModule(mod) {
        if(mod.id) {
          localStorage.setItem("currentModule", mod.id);
          localStorage.setItem("currentModuleName", mod.name);
          if(mod.learningStyleB)
            this.$router.push({ path: '/builderB', query: { moduleId: mod.id } });
          else
            this.$router.push({ path: '/builder', query: { moduleId: mod.id } });
        }else
          this.notification();
      },
      notification() {
        var retrievedData = localStorage.getItem("currentModule");
        if (!retrievedData) {
          this.active1 = true;
        }
      },
      showLoadingOnCourseTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.courseTable.$el,
          scale: 1
        });
      },
      showLoadingOnModuleTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.moduleTable.$el,
          scale: 1
        });
      },
    },
    mounted() {
      this.showLoadingOnCourseTable();
      this.loadCourseData();
      this.notification();
    },
  }

</script>
